import type { Summary } from '@memori-web/shared';

const KEY = 'memori-web:ai-cache';
const cache = new Map<string, Summary>();

function load() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (raw) {
      const obj = JSON.parse(raw) as Record<string, Summary>;
      for (const [k, v] of Object.entries(obj)) cache.set(k, v);
    }
  } catch {/* ignore */}
}
function save() {
  const obj: Record<string, Summary> = {};
  for (const [k, v] of cache) obj[k] = v;
  try { sessionStorage.setItem(KEY, JSON.stringify(obj)); } catch {/* ignore */}
}
load();

export function getCachedSummary(date: string): Summary | null {
  return cache.get(date) ?? null;
}

export function setCachedSummary(date: string, value: Summary): void {
  cache.set(date, value);
  save();
}
